import React from "react";

import CenterSection from "./component/CenterSection";
import HeroSection from "./pages/HeroSection";
import Header from "./component/Header";
import SuperiourCustomerServices from "./pages/SuperiourCustomerServices";
import ServingPanIndia from "./pages/ServingPanIndia";



const Home = () => {
  return (
    <div>
        <Header/>
      <HeroSection />
      <CenterSection/>
      <SuperiourCustomerServices/>
      <ServingPanIndia/>
      

    </div>
  );
};

export default Home;
